import React, { useContext, useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router'
import NavBar from '../components/global/NavBar'
import { useUserAuthStore } from '../stores/global/userAuth'
import { useAdministracaoStore } from '../stores/administracao/administracao'

interface ProtectedRouteProps {
  children: JSX.Element
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { token } = useUserAuthStore()
  const { screensPermissions, loadingScreensPermisssions } = useAdministracaoStore()
  const location = useLocation()
  const isAuthenticated = (): boolean => {
    if (!token) return false
    else {
      return true
    }
  }

  const acessoTela = (): boolean => {
    if (location.pathname == "/dashboard" || location.pathname == "/" || loadingScreensPermisssions == false) {
      return true
    }
    return screensPermissions.some(x => x.urlTelas && x.urlTelas.some(y => y == location.pathname))
  }

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />
  }

  if (!acessoTela() && loadingScreensPermisssions === false) {
    return <Navigate to="/Acesso_negado" replace />
  }

  return <>
    <NavBar>
      {children}
    </NavBar>
  </>
}

export default ProtectedRoute

